<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <form-create-or-update v-model="form" :errors="errors"></form-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="form"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import FormCreateOrUpdate from './components/FormCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        FormCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            form:{
                Id:0,
                Name:null
            },
            fields:[
                { name:"Yük Şekli",key:"Name", thClass:"w-100",sortable:true,},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.form.Id = 0
            this.form.Name = null
           
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.form.Id = item.Id
            this.form.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.Form.CreateOrUpdate(this.editing,this.form)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.Form.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} şeklini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.Form.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>